import React, { useState, useEffect } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axiosClient from 'http/axios-client';
import { useAlerts } from 'hooks/alerts-hooks';
import { roles } from 'cassandra-shared-js/roles';
import usePermissions from 'hooks/permissions-hooks';
import NewBusinessUserInfoDialog from 'components/basic/dialogs/NewBusinessUserInfoDialog';

const useStyles = makeStyles({
  newButton: {
    margin: '5px 5px 5px 5px',
    fontSize: 18,
    borderColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
});

function ManagerNewCorporate() {
  const classes = useStyles();
  const { userHasRole, role } = usePermissions();
  const [ newCorporationEmail, setNewCorporationEmail ] = useState('');
  const [ newCorporationName, setNewCorporationName ] = useState('');
  const [ newBranchEmail, setNewBranchEmail ] = useState('');
  const [ country, setCountry ] = useState('GR');
  const { alertSuccess, alertError } = useAlerts();
  const [ addBranch, setAddBranch ] = useState(false);
  const [ newPasswordModalOpen, setNewPasswordModalOpen ] = useState(false);
  const [ userDetails, setUserDetails ] = useState();

  let emailLocale = 'en-US';

  useEffect(() => {
    if (userHasRole(roles.AL_MANAGER)) {
      setCountry('AL');
    } else if (userHasRole(roles.ADMINISTRATOR_ROLE)) {
      setCountry('GR');
    }
  }, [ role ]);

  useEffect(() => {
    if (country === 'GR') {
      emailLocale = 'el-GR';
    } else {
      emailLocale = 'en-US';
    }
  }, [ country ]);

  const createBusiness = () => {
    if (newCorporationEmail !== '' && (!newCorporationEmail.includes('@') || !newCorporationEmail.includes('.'))) {
      alertError('Corporation Email is not correct');
      return;
    } if (newCorporationName.length === 0) {
      alertError('Name can not be empty');
      return;
    } if (addBranch && newBranchEmail !== '' && (!newBranchEmail.includes('@') || !newBranchEmail.includes('.'))) {
      alertError('Branch Email is not correct');
      return;
    }
    if (addBranch && newBranchEmail === '') {
      alertError('Branch Email is required');
      return;
    }

    const data = {
      type: 'Company',
      country,
      email_locale: emailLocale,
      address: {},
      brand_name: newCorporationName,
      email: newCorporationEmail.trim(),
    };

    axiosClient.post('/businesses/create-super-and-sub-user', data).then((dd) => {
      setNewCorporationEmail('');
      setNewCorporationName('');
      alertSuccess(`New Corporation ${ dd.brand_name } created successfully.`);
      if (addBranch && newBranchEmail !== '') {
        const BranchData = {
          type: 'Branch',
          country,
          email_locale: emailLocale,
          address: {},
          brand_name: newCorporationName,
          email: newBranchEmail.trim(),
          mother_business_id: dd.id,
        };
        axiosClient.post('/businesses/create-super-and-sub-user', BranchData).then((ddd) => {
          setNewBranchEmail('');
          alertSuccess(`New Branch ${ ddd.brand_name } created successfully.`);
        }).catch((e) => {
          alertError(`Fail to Create new Branch ${ e?.response?.data?.message }`);
        });
      }
      if (dd?.password !== undefined) {
        setUserDetails({
          email: dd.email,
          password: dd.password,
        });
        setNewPasswordModalOpen(true);
      }
      setAddBranch(false);
    }).catch((e) => {
      setUserDetails(undefined);
      alertError(`Fail to Create new Corporation ${ e?.response?.data?.message }`);
    });
  };

  return (
    <Grid
      container
      display='flex'
      alignItems='center'
      spacing={ 2 }
      style={ { backgroundColor: '#ffffff' } }
    >
      <Grid item xs={ 12 } display='flex'>
        <Typography variant='h5'>Add new Corporate</Typography>
      </Grid>
      {userHasRole(roles.ADMINISTRATOR_ROLE)
                && (
                  <Grid item xs={ 10 } display='flex'>
                    <Select
                      fullWidth
                      variant='outlined'
                      size='small'
                      labelId='country-select-label'
                      id='country-select'
                      value={ country }
                      onChange={ (e) => { setCountry(e.target.value); } }
                    >
                      <MenuItem value='GR'>Greece</MenuItem>
                      <MenuItem value='AL'>Albania</MenuItem>
                      <MenuItem value='IN'>India</MenuItem>
                      <MenuItem value='IQ'>Iraq</MenuItem>
                    </Select>
                  </Grid>
                )}
      <Grid item xs={ 10 } display='flex'>
        <TextField
          fullWidth
          id='newCorporationName'
          size='medium'
          value={ newCorporationName }
          onChange={ (e) => { setNewCorporationName(e.target.value); } }
          label='Enter Name'
          required
          variant='outlined'
          type='text'
        />
      </Grid>
      <Grid item xs={ 10 } display='flex'>
        <TextField
          fullWidth
          id='newCorporationEmail'
          size='medium'
          value={ newCorporationEmail }
          onChange={ (e) => { setNewCorporationEmail(e.target.value); } }
          label='Enter Corporation Email'
          variant='outlined'
          type='email'
        />
      </Grid>
      <Grid item xs={ 10 } display='flex'>
        <Typography>
          {' '}
          Add Branch with the same name to this corporation ?
          <Checkbox
            color='primary'
            onChange={ () => { setAddBranch(!addBranch); } }
          />
        </Typography>
        {addBranch
                && (
                  <TextField
                    fullWidth
                    id='newBranchEmail'
                    size='medium'
                    value={ newBranchEmail }
                    onChange={ (e) => { setNewBranchEmail(e.target.value); } }
                    label='Enter Branch Email *'
                    variant='outlined'
                    type='email'
                  />
                )}
      </Grid>
      <Grid item xs={ 12 } display='flex'>
        <Button
          className={ classes.newButton }
          variant='outlined'
          size='large'
          onClick={ () => { createBusiness(); } }
        >
          <span>ADD CORPORATION</span>
          <span>&nbsp;</span>
          {addBranch && <span>and Branch</span>}
        </Button>
      </Grid>
      { newPasswordModalOpen && userDetails.email !== undefined && (
        <NewBusinessUserInfoDialog
          open={ newPasswordModalOpen }
          handleClose={ () => {
            setNewPasswordModalOpen(false);
            setUserDetails(undefined);
          } }
          details={ userDetails }
        />
      )}
    </Grid>
  );
}

export default ManagerNewCorporate;
